import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconAddPlus(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M13 6a1 1 0 1 0-2 0v5H6a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5V6Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
